import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, DiamondIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const NAV_LINKS = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Services',
  path: '/services'
}, {
  name: 'Shop',
  path: '/shop'
}, {
  name: 'Courses',
  path: '/courses'
}, {
  name: 'Events',
  path: '/events'
}, {
  name: 'Community',
  path: '/community'
}, {
  name: 'About',
  path: '/about'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-warmwhite/90 backdrop-blur-md shadow-md py-3' : 'bg-warmwhite/70 backdrop-blur-sm py-4 md:py-5'}`} data-id="element-75" data-mp="elzk8msbiond">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76" data-mp="okyta6gzwmaw">
        <div className="flex items-center justify-between" data-id="element-77" data-mp="3n4f8b19jifmn">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-78" data-mp="3s1xkd0iutayv">
            <DiamondIcon className="w-6 h-6 text-fuchsia group-hover:text-plum transition-colors" data-id="element-79" data-mp="3s049f917k4l2" />
            <span className="font-display font-bold text-2xl text-plum tracking-tight" data-id="element-80" data-mp="ub7cha8vw5c">
              Silvermark
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-81" data-mp="34cmfp7yduwfg">
            {NAV_LINKS.map(link => {
            const isActive = location.pathname === link.path;
            return <Link key={link.name} to={link.path} className={`relative text-sm font-medium transition-colors hover:text-fuchsia ${isActive ? 'text-fuchsia' : 'text-charcoal'}`} data-id="element-82" data-mp="319go73biejv1">
                  {link.name}
                  {isActive && <motion.div layoutId="navbar-indicator" className="absolute -bottom-1 left-0 right-0 h-0.5 bg-fuchsia rounded-full" initial={false} transition={{
                type: 'spring',
                stiffness: 300,
                damping: 30
              }} data-id="element-83" data-mp="364cg83gqx785" />}
                </Link>;
          })}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block" data-id="element-84" data-mp="2m2mjcx6hgun">
            <Link to="/contact" className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white bg-fuchsia rounded-full hover:bg-fuchsia-light transition-colors shadow-sm hover:shadow-md" data-id="element-85" data-mp="2kzz5ez2dwjh">
              Get Started
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden p-2 -mr-2 text-charcoal hover:text-fuchsia transition-colors" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-86" data-mp="54xo9p7zw7m7">
            <MenuIcon className="w-6 h-6" data-id="element-87" data-mp="xt1ucbuhampf" />
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-88" data-mp="k2q0o8i8wfw6">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[60] bg-warmwhite flex flex-col lg:hidden" data-id="element-89" data-mp="o3s2mx3jr61u">
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-charcoal/10" data-id="element-90" data-mp="3k1j2ffxe748g">
              <Link to="/" className="flex items-center gap-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-91" data-mp="3f411abpm9tb0">
                <DiamondIcon className="w-6 h-6 text-fuchsia" data-id="element-92" data-mp="blpmp3avxwsg" />
                <span className="font-display font-bold text-2xl text-plum" data-id="element-93" data-mp="6o7oo7yep1z8">
                  Silvermark
                </span>
              </Link>
              <button className="p-2 text-charcoal hover:text-fuchsia transition-colors" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close menu" data-id="element-94" data-mp="1vobhc3ms8uy">
                <XIcon className="w-6 h-6" data-id="element-95" data-mp="ufmuiape61f8" />
              </button>
            </div>
            <nav className="flex-1 overflow-y-auto py-8 px-6 flex flex-col gap-6" data-id="element-96" data-mp="plil7ksnlhaz">
              {NAV_LINKS.map(link => {
            const isActive = location.pathname === link.path;
            return <Link key={link.name} to={link.path} className={`text-2xl font-display font-medium ${isActive ? 'text-fuchsia' : 'text-charcoal'}`} data-id="element-97" data-mp="2dahkabfjrhys">
                    {link.name}
                  </Link>;
          })}
            </nav>
            <div className="p-6 border-t border-charcoal/10" data-id="element-98" data-mp="2w6zbmrqhhfui">
              <Link to="/contact" className="flex items-center justify-center w-full px-6 py-4 text-lg font-medium text-white bg-fuchsia rounded-full hover:bg-fuchsia-light transition-colors" data-id="element-99" data-mp="2w55zwy10k5fn">
                Get Started
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}